import type { FaireProductEntity } from "../../entity_types/product";

export const p_wtdph9k988: FaireProductEntity = {
  token: "p_wtdph9k988",
  type: "product",
  name: "LM-BG-1004  REUSABLE TOTE - ZEBRA",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/e1cffc1f4e52f96e71495abf9f18a0fec68ae61cf0ba18b0840f0efa65fae8f3.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description: "This reusable tote from Girlie Girl Originals features a zebra motif and is designed for carrying items. The tote offers ample room and folds for storage. It blends functionality with an eye-catching aesthetic, suitable for errands or casual use.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:28.644Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
